import React, {Component} from 'react';
import "./BaseModal.scss"
import classNames from 'classnames';
import { bool, func } from 'prop-types';

class BaseModal extends Component {

    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            show: this.props.show,
            hideHeader: this.props.hideHeader,
            isNarrow: this.props.isNarrow,
            onClose: this.props.onClose
        }
    }

    closeModal(isManual) {
        if (this.props.onClose) {
            this.props.onClose(isManual);
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.show !== newProps.show) {

            // show/hide
            this.setState({ show: newProps.show });

            // if we're hiding, determine whether or not we want to fade out.
            if (!newProps.show) {
                // call close function
                this.closeModal()
            }
        }
    }

    render() {
        let headerClass = classNames('base-modal-header', { 'base-modal-hide-header': this.props.hideHeader });
        let containerClass = classNames('base-modal-container', { 'base-modal-narrow': this.props.isNarrow });
        return (
            <div className={classNames({ [this.props.baseClassName || '']: this.props.baseClassName })}>
                {this.state.show &&
                    <div className="base-modal-background">
                        <div className={containerClass}>
                        <div className={headerClass}>
                            {!this.props.hideCloseButton &&
                                <div className="base-modal-exit-button" onClick={() => this.closeModal(true)}>X</div>
                            }
                            </div>
                            <div className="base-modal-content">
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    };
}

BaseModal.propTypes = {
    show: bool,
    hideHeader: bool,
    isNarrow: bool,
    onClose: func,
    hideCloseButton: bool
}

export default BaseModal;